<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Referencias</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">

  <div class="row mb-2">
    @if (datosReferencias.data?.length) {
      <div class="col-md-12 my-4 overflow-auto">
        <table mat-table multiTemplateDataRows [dataSource]="datosReferencias"
          class="table d-xl-table d-md-table table-responsive my-2">
          <ng-container matColumnDef="Banco">
            <th mat-header-cell class="px-2" *matHeaderCellDef>Banco</th>
            <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.des_marca}}</td>
          </ng-container>
          <ng-container matColumnDef="Referencia">
            <th mat-header-cell class="px-2" *matHeaderCellDef>Referencias</th>
            <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.des_marca}}</td>
          </ng-container>
          <!-- Sin resultados -->
          <ng-container matColumnDef="noData">
            <td mat-footer-cell *matFooterCellDef colspan="2">
              <small>No existe información</small>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayColumns;"> </tr>
          <tr mat-footer-row *matFooterRowDef="['noData']"
            [ngClass]="(datosReferencias?.data?.length === 0) ? '':'ocultarPaginator'">
          </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20, 50,100]" showFirstLastButtons
          aria-label="Select page of periodic elements">
        </mat-paginator>
      </div>
    } @else {
      <div class="col-md-12">
        <small>No exite información</small>
      </div>
    }
  </div>
</mat-dialog-content>